import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminAPI } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Coins, AlertTriangle } from 'lucide-react';

const STATUS = {
  open: 'Aperta',
  charging: 'In addebito',
  charged: 'Addebitata',
  cancelled: 'Annullata',
};

const euro = (n) => `€${Number(n || 0).toFixed(2)}`;

/** Platform admin: every field collection, who receives it and what needs a look. */
export const AdminCollections = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    adminAPI.getCollections().then((res) => setRows(res.data)).catch(() => setRows([]));
  }, []);

  if (!rows?.length) return null;

  return (
    <Card data-testid="admin-collections">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Coins className="h-5 w-5" />
          Raccolte campo
        </CardTitle>
      </CardHeader>
      <CardContent className="divide-y">
        {rows.map((r) => {
          const problems = r.failed_transfers + r.failed_charges;
          return (
            <div key={r.match_id} className="py-3 flex flex-wrap items-center justify-between gap-2">
              <div className="min-w-0">
                <Link to={`/matches/${r.match_id}`} className="font-medium hover:underline">
                  {r.title || 'Partita'}
                </Link>
                <p className="text-xs text-muted-foreground">
                  {r.date_time?.replace('T', ' ').slice(0, 16)} · a {r.collector.name}
                  {r.collector.type === 'facility' && ' (struttura)'} · quota {euro(r.share)}
                </p>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <span className="font-mono">{euro(r.collected)} / {euro(r.target)}</span>
                <span className="text-xs text-muted-foreground">
                  {r.paid} pagate · {r.held} bloccate · inviati {euro(r.transferred)}
                </span>
                <Badge variant="outline">{STATUS[r.status] || r.status}</Badge>
                {problems > 0 && (
                  <Badge className="bg-red-600 hover:bg-red-600">
                    <AlertTriangle className="h-3 w-3 mr-1" />
                    {r.failed_transfers > 0 && `${r.failed_transfers} invii falliti`}
                    {r.failed_transfers > 0 && r.failed_charges > 0 && ' · '}
                    {r.failed_charges > 0 && `${r.failed_charges} carte rifiutate`}
                  </Badge>
                )}
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};

export default AdminCollections;
